import React from "react";
import { useTheme } from "react-jss";
import useStyles from "./ChoiceLabelRenderer.styles";
import { ChoiceModel } from "../../../models/ChoiceModel";
import useTranslatable from "../../../hooks/useTranslatable";

interface Props {
    choice: ChoiceModel;
    gridRendering?: boolean;
    fontWeight?: number;
}

export default function ChoiceLabelRenderer({ choice, gridRendering, fontWeight }: Props) {
    const theme: any = useTheme();
    const classes = useStyles({ theme, fontWeight });
    const id = `${choice.elementId}_LABEL`;
    const choiceLabel = useTranslatable(choice, "TEXT");

    return (
        !gridRendering && (
            <>
                {theme.DisplayChoiceIcon !== "none" && (
                    <span className={classes.spacer} aria-hidden="true" />
                )}
                <span
                    className={classes.choiceText}
                    id={id}
                    dangerouslySetInnerHTML={{ __html: choiceLabel }}
                />
            </>
        )
    );
}
